import * as React from "react";
import type { SVGProps } from "react";
const SvgPhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="phone_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M426.667 725.333a42.667 42.667 0 1 0 0 85.334h170.666a42.667 42.667 0 1 0 0-85.334H426.667zm-128-682.666A170.667 170.667 0 0 0 128 213.333v597.334a170.667 170.667 0 0 0 170.667 170.666h426.666A170.667 170.667 0 0 0 896 810.667V213.333A170.667 170.667 0 0 0 725.333 42.667H298.667zm-85.334 170.666A85.333 85.333 0 0 1 298.667 128h426.666a85.333 85.333 0 0 1 85.334 85.333v597.334A85.333 85.333 0 0 1 725.333 896H298.667a85.333 85.333 0 0 1-85.334-85.333V213.333z"
    />
  </svg>
);
export default SvgPhoneIcon;
